var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemovebuttons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.123,
    cy: 16,
    r: 15,
    stroke: "#909090",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8005 7.61289C12.8005 6.72212 13.5226 6 14.4134 6H17.6391C18.5299 6 19.252 6.72212 19.252 7.61289V8.41934C19.252 8.7825 19.132 9.11764 18.9295 9.38723H23.2842C23.6405 9.38723 23.9294 9.67607 23.9294 10.0324V13.2582C23.9294 13.6145 23.6405 13.9033 23.2842 13.9033H22.3165V24.5484C22.3165 25.3501 21.6666 26 20.8649 26H11.1875C10.3858 26 9.73594 25.3501 9.73594 24.5484V13.9033H8.7682C8.41189 13.9033 8.12305 13.6145 8.12305 13.2582V10.0324C8.12305 9.67607 8.41189 9.38723 8.7682 9.38723H13.123C12.9205 9.11764 12.8005 8.7825 12.8005 8.41934V7.61289ZM14.4134 7.4516H17.6391C17.7282 7.4516 17.8004 7.52381 17.8004 7.61289V8.41934C17.8004 8.50841 17.7282 8.58063 17.6391 8.58063H14.4134C14.3243 8.58063 14.2521 8.50841 14.2521 8.41934V7.61289C14.2521 7.52381 14.3243 7.4516 14.4134 7.4516ZM9.41336 10.6775H22.6391V12.613H9.41336V10.6775ZM21.0262 13.9033V24.7097H11.0263V13.9033H21.0262Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovebuttons);
export default __webpack_public_path__ + "static/media/removebuttons.0946cd2d.svg";
export { ForwardRef as ReactComponent };var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemovebuttons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.123,
    cy: 16,
    r: 15,
    stroke: "#909090",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8005 7.61289C12.8005 6.72212 13.5226 6 14.4134 6H17.6391C18.5299 6 19.252 6.72212 19.252 7.61289V8.41934C19.252 8.7825 19.132 9.11764 18.9295 9.38723H23.2842C23.6405 9.38723 23.9294 9.67607 23.9294 10.0324V13.2582C23.9294 13.6145 23.6405 13.9033 23.2842 13.9033H22.3165V24.5484C22.3165 25.3501 21.6666 26 20.8649 26H11.1875C10.3858 26 9.73594 25.3501 9.73594 24.5484V13.9033H8.7682C8.41189 13.9033 8.12305 13.6145 8.12305 13.2582V10.0324C8.12305 9.67607 8.41189 9.38723 8.7682 9.38723H13.123C12.9205 9.11764 12.8005 8.7825 12.8005 8.41934V7.61289ZM14.4134 7.4516H17.6391C17.7282 7.4516 17.8004 7.52381 17.8004 7.61289V8.41934C17.8004 8.50841 17.7282 8.58063 17.6391 8.58063H14.4134C14.3243 8.58063 14.2521 8.50841 14.2521 8.41934V7.61289C14.2521 7.52381 14.3243 7.4516 14.4134 7.4516ZM9.41336 10.6775H22.6391V12.613H9.41336V10.6775ZM21.0262 13.9033V24.7097H11.0263V13.9033H21.0262Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovebuttons);
export default __webpack_public_path__ + "static/media/removebuttons.0946cd2d.svg";
export { ForwardRef as ReactComponent };